import React, { useState, useEffect } from "react";
import { Button, Modal, Text } from "@telia/teddy";
import { Modal as ModalType } from "../../../../../../models";
import { isRunningOnClientSide } from "../../../../../../shared/util";
import "./ContentfulModal.less";
import { RenderCfContent } from "../../../../modals/utils/util";

interface Props {
    modal: ModalType;
    open: boolean;
    setOpen: (open: boolean) => void;
}

const ContentfulModal: React.FC<Props> = ({ modal, open, setOpen }) => {
    const [isClientSide, setIsClientSide] = useState(false);
    useEffect(() => {
        if (isRunningOnClientSide()) {
            setIsClientSide(true);
        }
    }, []);

    return (
        <>
            {isClientSide && (
                <>
                    <Modal onOpenChange={() => setOpen(false)} open={open}>
                        <Modal.Overlay className="contentful-modal">
                            <Modal.Content>
                                <Modal.Group variant="title">
                                    <Modal.Title as="h3">{modal.heading}</Modal.Title>
                                    <Text as="p">{modal.ingress}</Text>
                                </Modal.Group>
                                <Modal.Close slot="floating" aria-label="lukk" />
                                <Modal.Description>
                                    <RenderCfContent modal={modal} />
                                    <div className="contentful-modal__button-wrapper">
                                        <Button
                                            variant="primary"
                                            className="contentful-modal__button"
                                            onClick={() => setOpen(false)}
                                        >
                                            Lukk
                                        </Button>
                                    </div>
                                </Modal.Description>
                            </Modal.Content>
                        </Modal.Overlay>
                    </Modal>
                </>
            )}
        </>
    );
};

export default ContentfulModal;
